/**
 * SingleDropDown_JS parameters
 * @typedef {Object} SINGLE_DROPDOWN_PARAMETERS
 * @property {Boolean} disabled true for disable control
 * @property {String} ajaxurl ajax url
 * @property {String} ajaxData data to send via ajax
 * @property {Array.<SingleDropDownOption_JS>} values initial values
 * @property {String} containerSelector dropdown container
 * @property {String} requestMessage dropdown heading message
 * @property {Boolean} allOption all option visible
 * @property {Function} onError  on error raise a param function
 * @property {Function} onLoaded  on loaded data raise a param function
 * @property {Function} onSelect  on select element

/**
 * Single Dropdown Js
 */
class SingleDropDown_JS{
    /**
     * constructor
     * @param {SINGLE_DROPDOWN_PARAMETERS} params control parameters
     */
    constructor(params) {
        const _options = {
            disabled: false,
            allOption : true,
            ajaxurl: '',
            values : [],
            containerSelector: '.single-dropdown', 
            requestMessage: '',
            onError: null, 
            onLoaded: null, 
            onSelect: null,
            ...params
        }
        /**
         * control parameters
         * @type {SINGLE_DROPDOWN_PARAMETERS}
         */
        this.Options = _options;
        /**
         * dropdown container
         * @type {HTMLDivElement}
         */
        this.Container = document.querySelector(this.Options.containerSelector);
        /**
         * options container
         * @type {HTMLDivElement}
         */
        this.Items = null;
        /**
         * loading spinner span
         * @type {HTMLDivElement}
         */
        this.Spinner = null;
        /**
         * loading span
         * @type {HTMLSpanElement}
         */
        this.Loading = null;
        /**
         * initial message on the control
         * @type {HTMLSpanElement}
         */
        this.RequestMessage = null;
        /**
         * current value
         * @type {String}
         */
        this.Value = '';
        /**
         * options length
         * @type{Number}
         */
        this.NumberOptions = 0;

        this.init();
    }
    /**
     * initialized method
     */
    init() {
        if (!this.Container) {
            throw new Error('Invalid container');
        }

        
        if (!this.Container) {
            throw new Error('Invalid container');
        }
        
        this.Container.innerHTML = this.Template;
        this.Spinner =  this.Container.querySelector('.dropdown-spinner');
        this.Loading = this.Container.querySelector('.dropdown-loading');
        this.RequestMessage = this.Container.querySelector('.request-message');
        this.RequestMessage.textContent = this.Options.requestMessage;
        this.Items = this.Container.querySelector('.items');

        this.Disabled = this.Options.disabled;

        this.setValues(this.Options.values);

        //add events
        this.Container.addEventListener('click', this.activeDropdown.bind(this), false);
    }
    /**
     * set active Dropdown
     */
    activeDropdown() {
        if (!this.Disabled) {
            this.Container.classList.toggle('active');
        }
    }
    /**
     * empty inner items
     */
    clearOptions() {
        this.Items.innerHTML = '';
        this.NumberOptions = 0;
        if (this.Options.allOption) {
            this.addValue(new SingleDropDownOption_JS('Todos', '', ''));
        }
    }
    /**
     * add range of values
     * @param {Array.<SingleDropDownOption_JS>} values dropdown options
     * @returns {Array.<HTMLAnchorElement>} return DOM elements
     */
    addValues(values) {
        if (Array.isArray(values) && values.length > 0) {
            return values.map(v => this.addValue(v));
        }
    }
    /**
     *  option value
     * @param {SingleDropDownOption_JS} value  option value
     * @returns {HTMLAnchorElement} resulted DOM element
     */
    addValue(value) {
        const newElement = this.Items.appendChild(value.getHtmlElement(++this.NumberOptions))
        new bootstrap.Tooltip(newElement); // enable tooltip
        newElement.addEventListener('click', this.onClickOption.bind(this, value),false);
        return value;
    }
    /**
     * on click option
     * @param {SingleDropDownOption_JS} option dropdown option object
     * @param {Event} event 
     */
    onClickOption(option, event) {
        this.RequestMessage.textContent = option.Label;
        this.Value = option.Value;
        if (this.Options.onSelect) {
            this.Options.onSelect(option);
        }
    }
    /**
     * clear all option and set the values
     * @param {Array.<SingleDropDownOption_JS>} values collection of options
     * @returns {Array.<HTMLAnchorElement>} dom elements
     */
    setValues(values) {
        this.clearOptions();
        const arrayElements = this.addValues(values);
        if (this.Options.onLoaded) {
            this.Options.onLoaded(values);
        }
        return arrayElements;
    }
    /**
     * get data from server
     * @param {Object} data params to send to the server
     * @param {String} url  web service
     */
    async updateDataFromServer(data, url = '') {

        const _url = !!url ? url : this.Options.ajaxurl,
            _this = this;
        if (!_url) return;

        this.Disabled = true;
        this.Loading.classList.remove('visually-hidden');
        this.RequestMessage.classList.add('visually-hidden');
        this.RequestMessage.textContent = this.Options.requestMessage;
        this.Spinner.classList.add('spinner-border');
        AJAXCommunications_JS.AsyncPostJSON(_url, data)
            .then(
                /**
                 * @param {AJAX_RESPONSE} res 
                 */
                res => {
                    if (res.isRedirected) {
                        _this.notityErrorToUser(true);
                    }
                    else if (!res.data?.IsSuccessful) {
                        _this.notityErrorToUser(true, res.data.Reason);
                    }
                    else if (Array.isArray(res.data?.Response)) {
                        _this.setValues(res.data.Response.map(d => new SingleDropDownOption_JS(d.Label, d.Value, d.Description)));
                    }
                })
            .catch(
                /**
                 * @param {AJAX_ERROR} e 
                 */
                e => {
                    _this.notityErrorToUser(
                        false,
                        [
                        `Error detail message: ${e.message}, status: ${e.status}, status text: ${e.statusText}, stack : ${e.stack}]`
                        ]);
                })
            .finally(() => {
                _this.Disabled = false;
                this.Loading.classList.add('visually-hidden');
                this.RequestMessage.classList.remove('visually-hidden');
                this.Spinner.classList.remove('spinner-border');
            });
    }
    /**
     * notify errors
     * @param {Boolean} messageToUser true if the error is for user eyes
     * @param {Array.<String>} errors array of errors
     */
    notityErrorToUser(messageToUser, errors) {
        if (this.Options.onError) {
            this.Options.onError(messageToUser, errors);
        }
        else {
            console.error('SingleDropDown_JS has encounter an error. Check on network tab from Dev Tools.')
            Array.isArray(errors) && errors.forEach(e=>console.error(e));
        }
    }
    /**
     * Get template html element
     */
    get Template() {
        return `<div class="dropdown-spinner" role="status"></div>
                <span class="dropdown-loading visually-hidden">&nbsp;Cargando...</span>
                <span class='request-message'>seleccione una opcion</span>
                <span class="left-icon"></span>
                <span class="right-icon"></span>
                <div class="items"></div>`;
    }
    /**
     * get disabled status
     */
    get Disabled() {
        return this._disabled ?? false;
    }
    /**
     * disable dropdown
     * @param {Boolean} value 
     */
    set Disabled(value) {
        if (typeof value !== 'boolean') {
            return;
        }

        this._disabled = value;
        
        if (value) {
            this.Container.classList.remove('active');    
            this.Container.classList.add('drodown-disabled');    
        }
        else {
            this.Container.classList.remove('drodown-disabled');    
        }
    }
}
/**
 * dropdown option element
 */
class SingleDropDownOption_JS{
    /**
     * @param {String} label user value
     * @param {String} value hidden value
     * @param {String} toolTipDescription full description
     */
    constructor(label, value, toolTipDescription) {
        /**
         * user value
         * @type {String}
         */
        this.Label = label;
        /**
         * hidden value
         * @type {String}
         */
        this.Value = value;
        /**
         * description
         * @type {String}
         */
        this.Description = toolTipDescription;
        /**
         * current target
         * @type {HTMLAnchorElement}
         */
        this.CurrentTarget = null;
    }
    /**
     * get option Html Element
     * @param {Number} numberOfItem number of element
     * @returns {HTMLAnchorElement}
     */
    getHtmlElement(numberOfItem) {
        const _htmlA = document.createElement('a');
            
        _htmlA.href = "javascript:void(0)";
        _htmlA.style.setProperty('--i', numberOfItem);
        _htmlA.dataset.bsCustomClass = "custom-tooltip";
        _htmlA.dataset.bsToggle = "tooltip";
        !!this.Description && (_htmlA.dataset.bsTitle = this.Description);
        _htmlA.innerHTML = `<span></span>${this.Label}`;
        _htmlA.dataset.dropdownValue = this.value;
        _htmlA.SingleDropDownOption_JS = this;
        this.CurrentTarget = _htmlA;
        return _htmlA;
    }
}